import { render } from "./Projects.vue?vue&type=template&id=2bfccd60"
import script from "./Projects.vue?vue&type=script&lang=ts"
export * from "./Projects.vue?vue&type=script&lang=ts"
script.render = render

export default script